import {account} from '../../fundus/account';
import {ferry} from '../../services/ferry/ferry';


export function upgradePath(category: string) {
    switch (category) {
        case 'CTM+':
            return 'payment/upgrade/support';
        case '409a':
            return '/payment/upgrade/valuation';
    }
    return undefined;
}

export function maxRaisedBreakPoint(amount: number) {
    return [500000, 3000000, 6000000, 10000000, 25000000, 50000000].find((plan) => amount <= plan);
}

type PlanIndex = {[id: string]: account.plans};

const pricingCategories = ferry.sessionless_select<account.pricing_categories>('account.pricing_categories');
export const pricingPlans = ferry.sessionless_select<account.plans>('account.plans');
const pricingPlansObject = pricingPlans.then((plansArray) => {
    const plansObject: PlanIndex = {};
    plansArray.forEach((plan) => {
        plansObject[plan.plan] = plan;
    });
    return plansObject;
});

function calculatePricingPlan(categories: Array<account.pricing_categories>, plans: PlanIndex) {
    return (category: string, amount_raised: number, ttm_revenue: number) => {
        const money = Math.max((amount_raised || 0), 2 * (ttm_revenue || 0));
        const fullCategory = categories.find((cat) => cat.category === category);
        let plan = plans[fullCategory.starting_plan];

        while (plan.max_raised && money >= plan.max_raised) {
            plan = plans[plan.upgrade];
        }

        return plan;
    };
}

export function pricingPlan(category: string, amount_raised: number, ttm_revenue: number) {
    return Promise.all([pricingCategories, pricingPlansObject]).then(([categories, plans]) => {
        return calculatePricingPlan(categories, plans)(category, amount_raised, ttm_revenue);
    });
}

let cachedCategories: Array<account.pricing_categories>, cachedPlans: PlanIndex;
pricingCategories.then((categories) => cachedCategories = categories);
pricingPlansObject.then((plans) => cachedPlans = plans);

export function pricingPlanSync(category: string, amount_raised: number, ttm_revenue: number) {
    if (!cachedCategories || !cachedPlans) {
        throw "Haven't loaded pricing info yet.";
    }
    return calculatePricingPlan(cachedCategories, cachedPlans)(category, amount_raised, ttm_revenue);
}


// this function is only for automated tests
export function refreshPricing() {
    return Promise.all([
    ferry.sessionless_select<account.pricing_categories>('account.pricing_categories').then((categories) => cachedCategories = categories),
    ferry.sessionless_select<account.plans>('account.plans').then((plansArray) => {
        const plansObject: PlanIndex = {};
        plansArray.forEach((plan) => {
            plansObject[plan.plan] = plan;
        });
        return plansObject;
    }).then((plans) => cachedPlans = plans)
    ]);
}



// WEBPACK FOOTER //
// ./_src/services/payments/subscriptionPrices.ts